import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { DiaryEntryForm } from '../components/diary';
import api from '../api';
import { getAuthenticatedAccountId } from '../selectors/auth';
import { getSelectedProfile } from '../selectors/profiles';

class DiaryEntryEditContainer extends Component {
  componentDidMount() {
    this.props.entriesPatchReset({});
  }

  render() {
    const {
      entriesPatch,
      entriesPatchReset,
      onDiaryEntrySaved,
      accountId,
      profile,
      entry
    } = this.props;

    const handleSubmit = values => {
      entriesPatchReset({});
      const cleanedUpValues = _.pick(values, ['content', 'feeling', 'hidden']);
      
      entriesPatch(
        { accountId, profileId: profile.id, entryId: entry.id },
        {
          body: JSON.stringify({
            ...cleanedUpValues
          })
        }
      );
      onDiaryEntrySaved();
    };

    return (
      <DiaryEntryForm
        isNew={false}
        initialValues={entry}
        onSubmit={handleSubmit}
      />
    );
  }
}

DiaryEntryEditContainer.propTypes = {
  entriesPatch: PropTypes.func.isRequired,
  entriesPatchReset: PropTypes.func.isRequired,
  onDiaryEntrySaved: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  entry: PropTypes.shape({
    id: PropTypes.string
  }).isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    accountId: getAuthenticatedAccountId(state),
    profile: getSelectedProfile(state),
    ...ownProps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      entriesPatch: api.actions.entriesPatch,
      entriesPatchReset: api.actions.entriesPatch.reset
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  DiaryEntryEditContainer
);



// WEBPACK FOOTER //
// ./src/containers/DiaryEntryEditContainer.js